import { render, staticRenderFns } from "./TableListPersonsOnboarding.vue?vue&type=template&id=9479f006"
import script from "./TableListPersonsOnboarding.vue?vue&type=script&lang=js"
export * from "./TableListPersonsOnboarding.vue?vue&type=script&lang=js"
import style0 from "./TableListPersonsOnboarding.vue?vue&type=style&index=0&id=9479f006&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9479f006')) {
      api.createRecord('9479f006', component.options)
    } else {
      api.reload('9479f006', component.options)
    }
    module.hot.accept("./TableListPersonsOnboarding.vue?vue&type=template&id=9479f006", function () {
      api.rerender('9479f006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableListPersonsOnboarding.vue"
export default component.exports